// src/store/rolesSlice.js
import { createSlice } from "@reduxjs/toolkit";

const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    list: [],   // store roles as an array (can change to object if needed)
  },
  reducers: {
  
  },
});

export const { setRoles, addRole, clearRoles } = rolesSlice.actions;
export const rolesReducer = rolesSlice.reducer;
